module.exports = "<div> <group title=\"Action Sheet\"> <group-item title=1个按钮 right-desc=点击弹出 @click=triggerActionSheet1></group-item> <group-item title=取消按钮文案 right-desc=点击弹出 @click=triggerActionSheet2></group-item> <group-item title=为按钮添加Classes right-desc=点击弹出 @click=triggerActionSheet3></group-item> </group> <action-sheet :show.sync=actionSheet.show :buttons=actionSheet.buttons :cancel-text=actionSheet.cancelText></action-sheet> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demos/ActionSheet.vue
 ** module id = 180
 ** module chunks = 0
 **/